import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { ClassActiveNav } from '../NavMenu';
import { SubMenu, MenuItem } from 'react-pro-sidebar';
import { darkModeBackgroud } from '../../../utils/constants';
import { NavMenuItem } from '../../../domain/helpers/NavMenuItem';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../store/useLanguageStore';

interface ItemWithSubMenuProps {
    isCollapsed: boolean;
    selectedNav: string;
    navMenuItem: NavMenuItem;
    expandedSubMenuId: number | null;
    handleRedirect: (path: string) => void;
    handleSubMenuClick: (id: number) => void;
    activeSubMenu: (i: NavMenuItem) => ClassActiveNav;
    setExpandedSubMenuSettingId: React.Dispatch<React.SetStateAction<number | null>>;
}

export const ItemWithSubMenu: React.FC<ItemWithSubMenuProps> = ({
    isCollapsed, selectedNav, navMenuItem, expandedSubMenuId,
    handleRedirect, activeSubMenu, handleSubMenuClick, setExpandedSubMenuSettingId,
}) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    const isTextCentered = isCollapsed ? 'text-center' : '';
    const isItemCollapsed = isCollapsed ? `d-none` : '';

    const subMenuLabel = <div className={isTextCentered}>
        {navMenuItem.icon}
        <span className={isItemCollapsed}>{language[navMenuItem.name]}</span>
    </div>

    const handleOnOpenChange = (id: number) => {
        handleSubMenuClick(navMenuItem.id)
        setExpandedSubMenuSettingId(null);
    }

    return <SubMenu
        key={navMenuItem.id}
        label={subMenuLabel}
        style={darkMode ? { color: 'white' } : {}}
        open={expandedSubMenuId === navMenuItem.id}
        title={language[navMenuItem.name] || navMenuItem.name}
        onOpenChange={() => handleOnOpenChange(navMenuItem.id)}
        className={`nav-bar-item ${activeSubMenu(navMenuItem)}`}
    >
        {
            navMenuItem.subMenu?.map(sub =>

                <MenuItem
                    key={sub.id}
                    title={language[sub.name] || sub.name}
                    style={darkMode ? { background: darkModeBackgroud } : {}}
                    className={`${darkMode ? "nav-bar-sub-item-dark-mode" : "nav-bar-sub-item"}`}
                    onClick={() => handleRedirect(sub.route)}
                >
                    <CircleIcon sx={{ width: '10px', height: '10px', marginLeft: '2px' }} className={selectedNav === sub.route ? 'active-nav-sub-item' : ''} />
                    <span className="ms-3" style={selectedNav === sub.route ? { color: darkMode ? 'white' : '#58595a' } : {}} >
                        {language[sub.name]}
                    </span>
                </MenuItem>
            )
        }
    </SubMenu>
}
export default ItemWithSubMenu;